import React from 'react';

import PropTypes from 'prop-types';

import { Badge } from 'apps/auth/components/common/Badge/Badge';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper, PanelContent, PanelRightBlock, PanelRow } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';

export const PanelButton = (props) => {
    return (
        <Panel
            onClick={props.onClick}
            type={props.href ? 'link' : props.to ? 'reactLink' : 'button'}
            to={props.to}
            href={props.href}
            isHoverable
            negativeMargin
            dataTestId={props.dataTestId}
        >
            <DiskBadgeWrapper>
                <DiskBadge variant={props.variant ?? 'secondary'} iconName={props.icon} />
            </DiskBadgeWrapper>
            <PanelContent>
                <PanelRow>
                    <Text>{props.mainText}</Text>
                </PanelRow>
                {props.secondaryText && (
                    <PanelRow>
                        <Text size="secondary" color="secondary">
                            {props.secondaryText}
                        </Text>
                    </PanelRow>
                )}
            </PanelContent>
            {props.badge && (
                <PanelRightBlock>
                    <Badge variant={'primary'} caption={props.badge} />
                </PanelRightBlock>
            )}
        </Panel>
    );
};

PanelButton.propTypes = {
    onClick: PropTypes.func,
    /**
     * if we use 'to' property, this button will be a reactLink, otherwise it will be just button
     */
    to: PropTypes.string,
    variant: PropTypes.oneOf(['primary', 'secondary', 'tertiary']),
    icon: PropTypes.string,
    mainText: PropTypes.string,
    secondaryText: PropTypes.string,
    badge: PropTypes.string,
};
